import { auth } from 'config';
import React, { useEffect } from 'react';
import { clearCookie } from '@utils/cookieHelper';
import { logUserEvent } from '@analytics/amplifyLogging';
const LogOut: React.FC = () => {
    useEffect(() => {
        handleLogOut();
    }, []);
    const handleLogOut = async () => {
        logUserEvent({
            type: 'LogOut Component',
            action: 'LogOutButtonClickedInACP',
            description: 'User Logout Initiated in Auth customer portal.'
        });
        await auth.getOkta().signOut();
        auth.getOkta().tokenManager.clear();
        clearCookie();
    };
    return <></>;
};
export default LogOut;
